// src/components/Talleres/SinAutenticacion.jsx
import React from 'react';
import { Card, Result, Button, Alert } from 'antd';
import { UserOutlined, LoginOutlined, UserAddOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export default function SinAutenticacion() {
  const navigate = useNavigate();

  return (
    <Card className="shadow-xl">
      <Result
        icon={<UserOutlined style={{ fontSize: 64, color: '#0047bb' }} />}
        title="Debes iniciar sesión"
        subTitle="Para inscribirte en un taller necesitas tener una cuenta activa."
        extra={[
          <Button
            key="login"
            type="primary"
            size="large"
            icon={<LoginOutlined />}
            onClick={() => navigate('/login')}
          >
            Iniciar Sesión
          </Button>,
          <Button
            key="register"
            size="large"
            icon={<UserAddOutlined />}
            onClick={() => navigate('/registro')}
          >
            Registrarse
          </Button>
        ]}
      >
        <div className="text-center">
          <Alert
            message="¿Por qué necesito una cuenta?"
            description={
              <ul className="text-left mt-2 space-y-1">
                <li>• Gestionar tus inscripciones</li>
                <li>• Realizar pagos seguros</li>
                <li>• Acceder a tu historial</li>
                <li>• Inscribir familiares</li>
              </ul>
            }
            type="info"
            showIcon
          />
        </div>
      </Result>
    </Card>
  );
}
